import styled from "styled-components/macro";

import logo from "Payments/CreditCardAssets/LargeCardLogos/visa_logo.png";
import logoWhite from "Payments/CreditCardAssets/LargeCardLogos/visa_white.png";

export default function Visa() {
  return (
    <>
      <Background />
      <Logo src={logo} />
      <FadedLogo />
    </>
  );
}

const Background = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: linear-gradient(to bottom left, #21a2cc, #005385);
`;

const FadedLogo = styled.div`
  position: absolute;
  left: -20px;
  right: -30px;
  bottom: -6px;
  top: 0;
  opacity: 0.1;
  background-image: url(${logoWhite});
  background-size: contain;
  background-position: bottom center;
  background-repeat: no-repeat;
`;
const Logo = styled.img`
  position: absolute;
  top: 28px;
  right: 8%;
  width: 100px;
  max-width: calc(100% / 4);
`;
